
















































































































































import { Vue, Component } from 'vue-property-decorator';
import VoteButton from './components/VoteButton.vue';
import * as config from './config';
import { getdetail } from './api';
import { appShare, wxShareInfo } from '@/common/ts/common';


@Component({
  name: 'DetailPage',
  components: {
    VoteButton,
  },
})
export default class DetailPage extends Vue {
  mustWeChat: boolean = true;
  imgUrl: string = require('./img/banner.jpg');
  option = config.OPTHINES;
  detailData = {};
  volunteer = false;
  community = false;
  project = false;
  organization = false;
  base = false;
  created() {
    if (Number(this.$route.query.type) === 1) {
      this.volunteer = true;
      this.community = false;
      this.project = false;
      this.organization = false;
      this.base = false;
    } else if (Number(this.$route.query.type) === 2) {
      this.volunteer = false;
      this.community = false;
      this.project = false;
      this.organization = false;
      this.base = true;
    } else if (Number(this.$route.query.type) === 3) {
      this.volunteer = false;
      this.community = true;
      this.project = false;
      this.organization = false;
      this.base = false;
    } else if (Number(this.$route.query.type) === 4) {
      this.volunteer = false;
      this.community = false;
      this.project = true;
      this.organization = false;
      this.base = false;
    } else if (Number(this.$route.query.type) === 5) {
      this.volunteer = false;
      this.community = false;
      this.project = false;
      this.organization = true;
      this.base = false;
    }
    getdetail(this.option.voteName, Number(this.$route.query.id), this.$route.query.type)
    .then( (res: any) =>  this.detailData = res.data);
    this.$addPv(372);
    appShare({
      title: '2019年重庆市志愿服务先进典型宣传',
      url: window.location.href,
      subtitle: '2019年重庆市志愿服务先进典型宣传',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      classId: -1,
      id: -1,
      type: 3,
    });
    wxShareInfo({
      title: '2019年重庆市志愿服务先进典型宣传',
      subtitle: '2019年重庆市志愿服务先进典型宣传',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }

  votSuccess(res: any) {
    console.log(res);
    getdetail(this.option.voteName, Number(this.$route.query.id), this.$route.query.type)
    .then( (res: any) =>  this.detailData = res.data);
  }
}
